/* routine-gift-guard.js — 루틴 빌더 사은품 가드 (계획 §8)
 *
 * 루틴 번들(/pages/routine-builder 로 담김, line attribute 게이팅)의 구성품이
 * 카트에서 빠지면 사은품(오일 클렌저)이 정가로 남는다 — 이 스크립트가 자동 제거한다.
 * 반대로 사은품 라인이 병합/조작으로 qty≥2 또는 2라인 이상이 되면 함수가
 * fail-closed 로 할인을 끊으므로, 첫 라인 qty 1 로 정리해 FREE 를 복원한다.
 *
 * discount 함수(routine-bundle-discount)와 동일한 variant 화이트리스트를 쓴다.
 * 제품 개편 시 함수와 함께 이 목록도 갱신할 것.
 */
(function () {
  'use strict';

  var SERUM_IDS = [47343542108385, 48839603126497];
  var AMPOULE_IDS = [47947268423905, 46037646835937, 46468764434657, 46037593948385];
  var CREAM_IDS = [46035943293153, 48428986335457];
  /* 사은품은 0원 전용 상품(variant 가변)이라 속성으로 식별한다.
     _dmf_gift 를 임의 라인에 붙이는 조작은 "자기 라인이 삭제되는" 자해뿐이라 무해. */

  var busy = false;      /* 가드 자신의 /cart/change 호출 재진입 방지 (계획 §8) */
  var scheduled = null;

  function hasRole(items, ids) {
    return items.some(function (it) {
      return it.properties && it.properties._dmf_routine && ids.indexOf(it.variant_id) > -1;
    });
  }

  function change(payload) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    });
  }

  function check() {
    if (busy) return;
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = cart.items || [];
        var gifts = items.filter(function (it) {
          return it.properties && it.properties._dmf_gift === 'true';
        });
        if (!gifts.length) return;

        var bundleOk = hasRole(items, SERUM_IDS) && hasRole(items, AMPOULE_IDS) && hasRole(items, CREAM_IDS);

        /* 순차 실행할 변경 목록 구성 */
        var ops = [];
        if (!bundleOk) {
          gifts.forEach(function (g) { ops.push({ id: g.key, quantity: 0 }); }); /* 번들 깨짐 → 사은품 제거 */
        } else {
          if (gifts[0].quantity !== 1) ops.push({ id: gifts[0].key, quantity: 1 }); /* qty 병합 → 1 로 축소 */
          gifts.slice(1).forEach(function (g) { ops.push({ id: g.key, quantity: 0 }); }); /* 중복 라인 → 첫 라인만 유지 */
        }
        if (!ops.length) return;

        busy = true;
        return ops.reduce(function (p, op) {
          return p.then(function () { return change(op); });
        }, Promise.resolve()).then(function () {
          busy = false;
          /* 카트 페이지에서는 리로드로 UI 정합 (드로어 등은 다음 렌더에서 최신화) */
          if (window.location.pathname.indexOf('/cart') === 0) window.location.reload();
        });
      })
      .catch(function () { busy = false; });
  }

  /* cart 관련 fetch 응답 후 재검사 (디바운스). MutationObserver 등은 쓰지 않는다 — 계획 §8 */
  var origFetch = window.fetch;
  window.fetch = function () {
    var url = String(arguments[0] && arguments[0].url ? arguments[0].url : arguments[0] || '');
    var p = origFetch.apply(this, arguments);
    if (!busy && /\/cart\/(add|change|update|clear)/.test(url)) {
      p.then(function () {
        clearTimeout(scheduled);
        scheduled = setTimeout(check, 400);
      }).catch(function () {});
    }
    return p;
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', check);
  } else {
    check();
  }
})();
